<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">数据统计</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">学员学习记录</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">个人学习轨迹</a>
        </span>
      </div>
      <div class="framePage-body">
        
        <div class="operationControl flexdc" style="align-items: flex-start;">
          <div class="searchbox">
            <div title="课程名称" class="searchboxItem ci-full">
              <span class="itemLabel">课程名称:</span>
              <el-input
                v-model="ruleForm.projectCourseName"
                type="text"
                size="small"
                placeholder="请输入课程名称"
                clearable
              />
            </div>
            <div title="课件名称" class="searchboxItem ci-full">
              <span class="itemLabel">课件名称:</span>
              <el-input
                v-model="ruleForm.catalogName"
                type="text"
                size="small"
                placeholder="请输入课件名称"
                clearable
              />
            </div>
            
          </div>
          <div class="searchbox" style="margin-top:15px">
              <div title="开始学习时间" class="searchboxItem ci-full" >
              <span class="itemLabel" style="min-width:7rem">开始学习时间:</span>
              <el-date-picker
                v-model="ruleForm.startStudyTime"
                type="daterange"
                size="small"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
             <div title="结束学习时间" class="searchboxItem ci-full">
              <span class="itemLabel" style="min-width:7rem">结束学习时间:</span>
              <el-date-picker
                v-model="ruleForm.endStudyTime"
                type="daterange"
                range-separator="至"
                size="small"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
            <div class="df" style="padding-right:30px">
              <el-button type="primary" class="bgc-bv" round @click="getData()"
                >查询</el-button
              >
            </div>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table
              ref="multipleTable"
              :data="tableData"
              :height="tableHeight"
              size="small"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              stripe
            >
              <el-table-column
                label="序号"
                align="center"
                type="index"
                :index="indexMethod"
                fixed
              />
              <el-table-column
                label="学员姓名"
                align="left"
                show-overflow-tooltip
                minWidth="120"
                prop="userName"
              />
              <el-table-column
                label="课程名称"
                align="left"
                show-overflow-tooltip
                minWidth="200"
                prop="courseName"
              />
              <el-table-column
                label="课件名称"
                align="left"
                show-overflow-tooltip
                minWidth="200"
                prop="catalogName"
              />
              <el-table-column
                label="视频总时长"
                align="left"
                show-overflow-tooltip
                prop="kpointDuration"
                minWidth="150"
              >
              <template slot-scope="scope">
                  {{getTime(scope.row.kpointDuration)}}
              </template>
              </el-table-column>
              <el-table-column
                label="学习视频时长"
                align="left"
                show-overflow-tooltip
                prop="timeInterval"
                minWidth="120"
              >
              <template slot-scope="scope">
                  {{getTime(scope.row.timeInterval)}}
              </template>
              </el-table-column>
              <el-table-column
                label="开始学习时间"
                align="left"
                show-overflow-tooltip
                prop="startTime"
                minWidth="190"
              >
              <template slot-scope="scope">
                  {{scope.row.startTime | moment}}
              </template>
              </el-table-column>
              <el-table-column
                label="结束学习时间"
                align="left"
                show-overflow-tooltip
                prop="createTime"
                minWidth="180"
              >
              <template slot-scope="scope">
                  {{scope.row.createTime | moment}}
              </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum
          :apiData="apiData"
          @sizeChange="sizeChange"
          @getData="getData"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import moment from "moment";

export default {
  name: "personStudyTrajectoryList",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      dialogVisible: false,
      userName: "",
      mobile: "",
      courseName: "",
      idcard: "",
      userId: "",
      projectCourseId: "",
      ruleForm: {
        projectCourseName:'',
        catalogName: "",
        startStudyTime: [],
        endStudyTime: [],
      },
      Obj: {},
    };
  },
  created() {
    this.Obj = JSON.parse(this.$route.query.data);
    console.log(this.Obj);
    this.userName = this.Obj.userName;
    this.mobile = this.Obj.mobile;
    this.courseName = this.Obj.courseName;
    this.idcard = this.Obj.idcard;
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    init() {
      this.getTableHeight();
      this.getData(-1);
    },
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        userId: this.$route.query.userId,
        projectCourseId: this.$route.query.projectCourseId,
        projectId: this.$route.query.projectId,
      };
      if (this.ruleForm.projectCourseName) {
        params.projectCourseName = this.ruleForm.projectCourseName;
      }
      if (this.ruleForm.catalogName) {
        params.catalogName = this.ruleForm.catalogName;
      }
      if (this.ruleForm.startStudyTime) {
        params.startStartDate = this.ruleForm.startStudyTime[0];
        params.startEndDate = this.ruleForm.startStudyTime[1];
      }
      if (this.ruleForm.endStudyTime) {
        params.createStartDate = this.ruleForm.endStudyTime[0];
        params.createEndDate = this.ruleForm.endStudyTime[1];
      }
      this.doFetch({
        url: "/gov/course/study/track/queryStudyTrackList",
        params,
        pageNum,
      });
    },
    getTime(val) {
      if (!val) {
        return "0秒";
      }
      let h = parseInt(val / 60 / 60);
      let m = parseInt((val % 3600) / 60);
      let s = val % 60;
      if (h < 9) {
        h = "0" + h;
      }
      if (m < 9) {
        m = "0" + m;
      }
      if (s < 9) {
        s = "0" + s;
      }
      return (
        (h != "00" ? h + "时" : "") +
          (m != "00" ? m + "分" : "") +
          (s != "00" ? s + "秒" : "") || ""
      );
    },
    /* 获取高度 */
    getTableHeight(opDom = true, page = true) {
      let tHeight =
        window.innerHeight - (3 + 1.35 + 3.25 + 0.675 + 2 + 1.35) * 16;
      if (opDom) {
        tHeight -= 40 + 0.675 * 16 + 1;
      }
      if (page) {
        tHeight -= 60;
      }
      this.tableHeight = tHeight;
    },
  },
};
</script>
<style lang="less">
.operationControlCurr {
  > div {
    width: 100%;
    justify-content: space-between;
  }
  .el-form {
    display: flex;
    .el-form-item__label {
      padding: 0 8px 0 0 !important;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .btns {
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
</style>
